import type { ReactNode } from 'react'

export const SpeechBubble = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => (
  <div
    className={className}
    css={theme => ({
      position: 'relative',
      padding: theme.spacing(2),
      backgroundColor: theme.semantic.ColorAccessoryReducedAlternative,
      borderRadius: '6px 6px 6px 0',
      border: `1px solid ${theme.semantic.ColorBorderOnActionSecondaryDefault}`,
      marginBottom: '13px',
      '&:before': {
        content: '" "',
        position: 'absolute',
        left: -1,
        right: 'auto',
        top: 'auto',
        bottom: '-15.5px',
        border: '7.5px solid',
        borderColor: `${theme.semantic.ColorBorderOnActionSecondaryDefault} transparent transparent ${theme.semantic.ColorBorderOnActionSecondaryDefault}`,
      },
      '&:after': {
        content: '" "',
        position: 'absolute',
        left: 0,
        right: 'auto',
        top: 'auto',
        bottom: '-13px',
        border: '7px solid',
        borderColor: `${theme.semantic.ColorAccessoryReducedAlternative} transparent transparent ${theme.semantic.ColorAccessoryReducedAlternative} `,
      },
    })}
  >
    {children}
  </div>
)
